import React, { Component } from 'react';
import styled, { injectGlobal } from 'styled-components';
import Column from './Column';
import reorder, { reorderQuoteMap } from '../../utils/dnd';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { colors } from './constants';
import styles from './styles';
import {
  getColumnNames,
  findById
} from './data';

const isDraggingClassName = 'is-dragging';

const ParentContainer = styled.div`
  height: ${({ height }) => height};
  overflow-x: hidden;
  overflow-y: auto;
`;

const Container = styled.div`
  padding-right: 4px;
  background: none;
  height: ${({ height }) => height};
  /* like display:flex but will allow bleeding over the window width */
  display: inline-flex;
  overflow-y: hidden;
  overflow-x: scroll;
  width: 100%;
`;

export default class Board extends Component {

  constructor(props) {
    super(props);
    this.state = {
      columns: this.props.initial,
      ordered: getColumnNames(this.props.initial),
      autoFocusQuoteId: null,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.columns && this.state.ordered && this.state.columns.length === 0 && this.state.ordered.length === 0) {
      this.setState({
        columns: nextProps.initial,
        ordered: getColumnNames(nextProps.initial),
      });
    }
    this.setState({
      columns: nextProps.initial,
    });
  }

  componentDidMount() {
    injectGlobal`
      body.${isDraggingClassName} {
        cursor: grabbing;
        user-select: none;
      }
    `;
  }

  onDragStart = (initial) => {
    // $ExpectError - body wont be null
    document.body.classList.add(isDraggingClassName);

    this.setState({
      autoFocusQuoteId: null,
    });
  }

  onDragEnd = (result) => {
    // $ExpectError - body wont be null
    document.body.classList.remove(isDraggingClassName);

    // dropped nowhere
    if (!result.destination) {
      return;
    }

    const source = result.source;
    const destination = result.destination;
    const currentId = result.draggableId;

    // reordering column
    if (result.type === 'COLUMN') {
      const ordered = reorder(
        this.state.ordered,
        source.index,
        destination.index
      );

      this.setState({
        ordered,
      });

      return;
    }

    const data = reorderQuoteMap({
      quoteMap: this.state.columns,
      source,
      destination,
      currentId,
    });

    let newQuoteMap = null;

    if (data.result) {
      newQuoteMap = data.result.quoteMap;
    } else {
      newQuoteMap = data.quoteMap.quoteMap;
    }

    this.setState({
      columns: newQuoteMap,
      autoFocusQuoteId: data.autoFocusQuoteId,
    });

    this.props.handler({
      id: result.draggableId,
      destination: result.destination.droppableId,
    });
  }

  render() {
    const columns = this.state.columns;
    const ordered = this.state.ordered;
    const { containerHeight } = this.props;

    const board = (
      <Container>
        {ordered.map((item) => {
          const quotes = findById(columns, item.id);

          return (
            <Column
              key={item.id}
              title={item.name}
              colCount={ordered.length}
              quotes={quotes}
              extraFieldToShow={this.props.extraFieldToShow}
              lanesList={this.props.lanesList}
              autoFocusQuoteId={this.state.autoFocusQuoteId}
              handlerOpenTask={this.props.handlerOpenTask}
              handlerOpenPreView={this.props.handlerOpenPreView}
              isFullScreen={this.props.isFullScreen}
            />
          )
        })
        }
      </Container>
    );

    return (
      <DragDropContext
        onDragStart={this.onDragStart}
        onDragEnd={this.onDragEnd}
      >
        {this.props.containerHeight ? (
          <ParentContainer height={containerHeight}>{board}</ParentContainer>
        ) : (
          board
        )}
      </DragDropContext>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Board.js